// @flow
import * as materialAppearance from './material'
import type { Styles } from '..'

export const Container = (props: Styles) => ({
  ...materialAppearance.Container(props),
  opacity: 1,
  minHeight: '42px',
  marginTop: '4px',
})

export const Content = {
  ...materialAppearance.Content,
  marginTop: '2px',
}

export const PrefixWrapper = (props: Styles) => ({
  ...materialAppearance.PrefixWrapper(props),
  color: props.$focus ? `${props.$palette('primary')}` : '#888888',
})

export const Label = (props: Styles) => ({
  ...materialAppearance.Label(props),
  color: props.$palette('#888888').setAlpha(0.5).toString(),
  fontWeight: 'bold',
  fontSize: '12px',
  left: '10px',
  top: '4px',
  height: '16px',
  transform: 'initial',
  transformOrigin: 'initial',
})

export const InputWrapper = (props: Styles) => ({
  ...materialAppearance.InputWrapper(props),
  color: props.$disabled ? '#DDDDDD' : `${props.$palette('TEXT')}`,
  minHeight: '24px',
  lineHeight: 'initial',
  marginTop: '16px',
  marginLeft: '10px',
})

// The line above the input
export const Baseline = {
  display: 'none',
}
